import React from "react";

import { useNavigation, useNotification } from "@refinedev/core";

import { MergeButton } from "@/components/common/merge-button";
import { RemoteSelect } from "@/components/fields/remote-select";
import { useVenueRepository } from "@/pages/venues/hooks/use-venue-repository";
import { VenueNestedType } from "@/pages/venues/schemas/venue.nested.form";

export const VenueMergeButton = ({ id }: { id: string }) => {
  const { search, merge } = useVenueRepository();
  const { open } = useNotification();
  const { edit } = useNavigation();
  const [value, setValue] = React.useState<VenueNestedType>();
  const [loading, setLoading] = React.useState(false);

  return (
    <MergeButton
      loading={loading}
      resource="venues"
      onConfirm={async (close) => {
        if (value) {
          open?.({
            type: "success",
            message: `Merging venue ${id} into ${value.name}...`,
          });
          setLoading(true);
          await merge(id, value.id).finally(() => setLoading(false));
          edit("venues", value.id);
          close();
        } else
          open?.({
            type: "error",
            message: "Please select a venue to merge into",
          });
      }}
    >
      <RemoteSelect<VenueNestedType>
        value={value}
        onSearch={async (query) => {
          const response = await search(query);
          return response.filter((d) => d.id !== id);
        }}
        onValueChanged={(value) => {
          if (value) setValue(value);
        }}
        showSelected
        accessorFn={(option) => ({
          id: option?.id || "",
          name: option ? `${option?.name} (${option?.address})` : "",
          iconUrl: option?.media?.photos[0]?.url,
        })}
      />
    </MergeButton>
  );
};
